import { Calendar, Icon } from "@/ds";
import styles from "../../../../obras-screen.module.scss";
import type { ObrasDateFilterViewModel } from "./types-obras-date-filter";

/**
 * Ícones DENTRO da caixa (Figma 11161:217285): sem o botão acoplado do Calendar (`showIcon`), o calendário fica à
 * esquerda e o chevron à direita; o clique passa para o campo.
 */
export function ObrasDateFilterView({ range, onChange, isFilled }: ObrasDateFilterViewModel) {
  const className = `${styles.dateField} ${isFilled ? styles.dateFieldFilled : ""}`.trim();

  return (
    <div className={className} data-testid="obras-date-filter">
      <Calendar
        className={styles.dateCalendar}
        inputClassName={styles.dateInput}
        selectionMode="range"
        inputId="obras-date"
        value={range}
        onChange={(event) => onChange(event.value)}
        placeholder="Data"
        aria-label="Data"
        showIcon={false}
      />
      <span className={`${styles.dateIcon} ${styles.dateIconStart}`} aria-hidden="true">
        <Icon name="calendar" size={14} />
      </span>
      <span className={`${styles.dateIcon} ${styles.dateIconEnd}`} aria-hidden="true">
        <Icon name="chevron-down" size={14} />
      </span>
    </div>
  );
}
